// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7664 ? "reactPlayerPreview" : chunkId) + "." + {"2925":"49312339665e8078","5389":"0e3ec8de7c9bd8a3","7664":"87ca7bd8f02ac44a"}[chunkId] + ".js";
};